import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { NameSpace } from '../../const';
import { MainData } from '../../types/state';
import { FetchDataMainParams, FetchDataMainSuccessPayload, AddAnswerParams, AddQuestionnaireParams } from '../../types/request';
import { buildDataMain } from '../../utils/data-table';

const initialState: MainData = {
  data: null,
  fetchingStatusMainData: false,
};

export const dataMain = createSlice({
  name: NameSpace.DataMain,
  initialState,
  reducers: {
    fetchDataMainRequest: (state, payload: PayloadAction<FetchDataMainParams>) => {
      state.fetchingStatusMainData = true;
    },
    fetchDataMainSuccess: (state, action: PayloadAction<FetchDataMainSuccessPayload>) => {
      state.fetchingStatusMainData = false;
      const { data, params } = action.payload;
      state.data = buildDataMain(data, params.quarter, params.year);
    },

    fetchCommentsOnlyRequest: (state, payload: PayloadAction<FetchDataMainParams>) => {},
    fetchCommentsOnlySuccess: (state, action: PayloadAction<{ comments: any[] }>) => {
      if (!state.data) return;
      const { comments } = action.payload;
      const commentedRequirementIds = new Set(comments.map((comment) => comment.demandID));
      const newData = JSON.parse(JSON.stringify(state.data));

      let updatedCount = 0;
      newData.data.forEach((block: any) => {
        block.groupRequirements.forEach((requirement: any) => {
          const hasComment = commentedRequirementIds.has(requirement.requirementId);

          requirement.answers.forEach((answer: any) => {
            const oldValue = answer.comments;
            answer.comments = hasComment ? ['Comment'] : null;
            if (oldValue !== answer.comments) {
              updatedCount++;
            }
          });
        });
      });
      state.data = newData;
    },

    fetchActionsOnlyRequest: (state, payload: PayloadAction<FetchDataMainParams>) => {},
    fetchActionsOnlySuccess: (state, action: PayloadAction<{ actions: any[] }>) => {
      if (!state.data) return;
      const { actions } = action.payload;
      const actionRequirementIds = new Set(actions.map((action) => action.demandID));
      const newData = JSON.parse(JSON.stringify(state.data));

      let updatedCount = 0;
      newData.data.forEach((block: any) => {
        block.groupRequirements.forEach((requirement: any) => {
          const hasAction = actionRequirementIds.has(requirement.requirementId);
          const oldValue = requirement.actions;
          requirement.actions = hasAction ? ['Action'] : null;
          if (oldValue !== requirement.actions) {
            updatedCount++;
          }
        });
      });
      state.data = newData;
    },

    createAnswerRequest(state, payload: PayloadAction<AddAnswerParams>) {},
    createAnswerSuccess: (state, action: PayloadAction<AddAnswerParams>) => {
      if (!state.data) return;

      const {
        id,
        answer,
        department: { title: departmentTitle },
        requirement: { id: requirementId },
      } = action.payload.data[0];

      for (const block of state.data.data) {
        for (const requirement of block.groupRequirements) {
          if (requirement.requirementId === requirementId) {
            for (const ans of requirement.answers) {
              if (ans.department === departmentTitle) {
                ans.answerId = id;
                ans.answer = answer;
                ans.isEdit = true;
                return;
              }
            }
          }
        }
      }
    },
    updateAnswerRequest(state, payload: PayloadAction<Pick<AddAnswerParams, 'answer'>>) {},
    updateAnswerSuccess: (state, action: PayloadAction<AddAnswerParams>) => {
      if (!state.data) return;

      const {
        answer,
        department: { title: departmentTitle },
        requirement: { id: requirementId },
      } = action.payload.data;

      for (const block of state.data.data) {
        for (const requirement of block.groupRequirements) {
          if (requirement.requirementId === requirementId) {
            for (const ans of requirement.answers) {
              if (ans.department === departmentTitle) {
                ans.answer = answer;
                return;
              }
            }
          }
        }
      }
    },
    createQuestionnaireRequest(state, payload: PayloadAction<AddQuestionnaireParams>) {},
    createQuestionnaireSuccess: (state, action: PayloadAction<AddQuestionnaireParams>) => {
      if (!state.data) return;

      const { id, statusQuestionnaire } = action.payload.data;

      state.data.statusQuestionnaire = {
        id: id,
        title: statusQuestionnaire,
      };
    },
    updateQuestionnaireRequest(state, payload: PayloadAction<AddQuestionnaireParams>) {},
    updateQuestionnaireSuccess: (state, action: PayloadAction<Pick<AddQuestionnaireParams, 'statusQuestionnaire'>>) => {
      if (!state.data) return;

      const { id, statusQuestionnaire } = action.payload.data;

      state.data.statusQuestionnaire = {
        id: id,
        title: statusQuestionnaire,
      };
    },
  },
});

export const {
  fetchDataMainRequest,
  fetchDataMainSuccess,
  fetchCommentsOnlyRequest,
  fetchActionsOnlyRequest,
  fetchActionsOnlySuccess,
  fetchCommentsOnlySuccess,
  createAnswerRequest,
  createAnswerSuccess,
  updateAnswerRequest,
  updateAnswerSuccess,
  createQuestionnaireRequest,
  createQuestionnaireSuccess,
  updateQuestionnaireRequest,
  updateQuestionnaireSuccess,
} = dataMain.actions;
